<template>
  <confirm-action-dialog
    :persistent="true"
    :title="$t('attachmentRequest.continueDialog.title')"
    :subtitle="$t('attachmentRequest.continueDialog.subtitle')"
    :isDialogActive="true"
    :leftText="$t('attachmentRequest.continueDialog.abort')"
    :rightText="$t('attachmentRequest.continueDialog.continue')"
    :hideClose="true"
    @leftClick="abort"
    @rightClick="next"
    @close="abort"
  >
    <a v-if="isMobile" href="#" @click="restart">
      {{ $t("components.partner.PartnerReportInitializeCard.empty.title") }}
    </a>

    <template #left v-if="!isMobile">
      <v-btn text @click="restart">{{ $t("attachmentRequest.continueDialog.restart") }}</v-btn>
    </template>
  </confirm-action-dialog>
</template>

<script lang="ts">
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { ApplicationInsightsEventEnum } from "@/lib/enum/application-insights-event.enum";
import { AttachmentResponseModule } from "@/store/modules/attachment-response.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { ConfirmActionDialog }
})
export default class AttachmentRequestContinueDialog extends Vue {
  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  async mounted() {
    this.$appInsights.trackEvent(
      { name: ApplicationInsightsEventEnum.OPEN_ATTACHMENT_REQUEST_CONTINUE_DIALOG },
      { partnerId: PartnerModule.partner.id }
    );
  }

  abort() {
    this.$log.info("AttachmentResponse aborted");
    AttachmentResponseModule.clearOngoingAttachmentRequest();

    this.$emit("close");
  }

  async next() {
    await this.$router.push({
      name: "ReportDataResponse",
      params: {
        accessToken: AttachmentResponseModule.attachmentRequestToken || ""
      }
    });
    this.$emit("close");
  }

  async restart() {
    this.abort();

    await this.$router.push({
      name: "ReportHome"
    });
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
